import React from 'react';
import SuggestedBusinessCCLoans from 'partial/OfferManager/modules/SuggestedBusinessCCLoans';
import ReduceCreditUsageWithLimitIncrease from 'partial/OfferManager/modules/ReduceCreditUsageWithLimitIncrease';
import AutoInsuranceForNewAutoLoan from 'partial/OfferManager/modules/AutoInsuranceForNewAutoLoan';
import NativeAdModule from 'partial/OfferManager/modules/NativeAdModule';
import FeaturedAdModule from 'partial/OfferManager/modules/FeaturedAd';
import PartnerTextDisclaimer from 'partial/OfferManager/modules/PartnerTextDisclaimer';
import CollectionGuideBanner from 'components/CollectionGuideBanner';
import DiscrepancyController from 'pages/Discrepancy/DiscrepancyController';
import Alert from 'partial/OfferManager/modules/Alert';
import AutoDDPending from 'partial/OfferManager/modules/AutoDDPending/AutoDDPendingController';
import AutoDDSuccess from 'partial/OfferManager/modules/AutoDDSuccess/AutoDDSuccessController';
import AutoInsuranceForCreditScoreIncrease from 'partial/OfferManager/modules/AutoInsuranceForCreditScoreIncrease';
import AutoInsuranceModule from 'partial/OfferManager/modules/AutoInsuranceModule';
import AutoInsuranceOcfModuleController from 'partial/OfferManager/modules/AutoInsuranceOcf';
import AutoLoanMarketplaceModule from 'partial/OfferManager/modules/AutoLoanMarketplaceModule';
import AutoLoanPurchaseModule from 'partial/OfferManager/modules/AutoLoanPurchaseModule';
import AutoLoanRateComparisonModule from 'partial/OfferManager/modules/AutoLoanRateComparisonModule';
import AutoPurchaseOcfModuleController from 'partial/OfferManager/modules/AutoPurchaseOcfModule';
import AutoRefinance from 'partial/OfferManager/modules/AutoRefinance';
import AutoRefinanceMarketplaceModule from 'partial/OfferManager/modules/AutoRefinanceMarketplaceModule';
import AutoRefinanceOcfModuleController from 'partial/OfferManager/modules/AutoRefinanceOcfModule';
import BalanceTransferOcfModule from 'partial/OfferManager/modules/BalanceTransferOcfModule';
import BusinessLoansOffers from 'partial/OfferManager/modules/BusinessLoansOffers';
import BuyCarTipModule from 'partial/OfferManager/modules/BuyCarTipModule';
import CROABanner from 'partial/OfferManager/modules/CROABanner';
import CardShippingAddress from 'partial/OfferManager/modules/CardShippingAddress';
import { CashBalanceModule } from 'partial/OfferManager/modules/CashBalance/CashBalanceModule';
import CashFundAccount from 'partial/OfferManager/modules/CashFundAccount';
import CashPerks from 'partial/OfferManager/modules/CashPerks';
import CreditAge from 'partial/OfferManager/modules/CreditAge';
import CreditCardComparison from 'partial/OfferManager/modules/CreditCardComparison';
import CreditFoundation from 'partial/OfferManager/modules/CreditFoundation';
import CreditLimit from 'partial/OfferManager/modules/CreditLimit';
import CreditRepairExpert from 'partial/OfferManager/modules/CreditRepairExpert';
import PersonalLoanPrequalModule from 'partial/OfferManager/modules/PersonalLoanPrequalModule';
import PersonalLoanPrequalHighCcDebtModule from 'partial/OfferManager/modules/PersonalLoanPrequalHighCcDebtModule';
import PersonalLoanHighScoreModule from 'partial/OfferManager/modules/PersonalLoanHighScoreModule';
import PlPrequalOfferModule from 'partial/OfferManager/modules/PlPrequalOfferModule';
import CreditRepairExpertTip from 'partial/OfferManager/modules/CreditRepairExpertTip';
import CreditUtilization from 'partial/OfferManager/modules/CreditUtilization';
import DebtAnalysis from 'partial/OfferManager/modules/DebtAnalysis';
import DebtRelief from 'partial/OfferManager/modules/DebtRelief';
import Default from 'partial/OfferManager/modules/Default';
import DirectDepositAutomatic from 'partial/OfferManager/modules/DirectDepositAutomatic/DirectDepositAutomaticController';
import DirectDepositManual from 'partial/OfferManager/modules/DirectDepositManual/DirectDepositManualController';
import GenericAutoLoanModule from 'partial/OfferManager/modules/GenericAutoLoanModule';
import GoalNegativeMarks from 'partial/OfferManager/modules/GoalNegativeMarks';
import HelpAndQuestions from 'partial/OfferManager/modules/HelpAndQuestions';
import HomeOwnerInsuranceOcfModule from 'partial/OfferManager/modules/HomeOwnerInsurance/modules/HomeOwnerInsuranceOcfModule';
import RentersInsuranceOcfModule from 'partial/OfferManager/modules/HomeOwnerInsurance/modules/RentersInsuranceOcfModule';
import HomePadder from 'partial/OfferManager/modules/HomePadder';
import HomePurchaseOcfModuleController from 'partial/OfferManager/modules/HomePurchaseOcf';
import HomeRefinanceOcfModuleController from 'partial/OfferManager/modules/HomeRefinanceOcf';
import IncreaseScoreTips from 'partial/OfferManager/modules/IncreaseScoreTips';
import KYCHardFail from 'partial/OfferManager/modules/KYCHardFail';
import KYCSoftFail from 'partial/OfferManager/modules/KYCSoftFail';
import LifeInsuranceModule from 'partial/OfferManager/modules/LifeInsuranceModule';
import LifeInsuranceOcfModuleController from 'partial/OfferManager/modules/LifeInsuranceOcf';
import MarketPlaceInsuranceTilesModule from 'partial/OfferManager/modules/MarketPlaceInsuranceTilesModule/MarketPlaceInsuranceTilesModule';
import MarketplacePreApprovedBanner from 'partial/OfferManager/modules/MarketplacePreApprovedBanner';
import NegativeMarks from 'partial/OfferManager/modules/NegativeMarks';
import NotificationAlertsDetailsModuleController from 'partial/OfferManager/modules/NotificationAlertsDetails';
import OneClickApplicationModule from 'partial/OfferManager/modules/OneClickApplication';
import PersonalLoanLowScoreModuleController from 'partial/OfferManager/modules/PersonalLoanLowScoreModule';
import PreApprovedOcfModuleController from 'partial/OfferManager/modules/PreApprovedOcf';
import PremiumFeatures from 'partial/OfferManager/modules/PremiumFeatures/PremiumFeatures';
import PremiumUpsell from 'partial/OfferManager/modules/PremiumUpsell';
import RecentCashTransactions from 'partial/OfferManager/modules/RecentCashTransactions';
import RentPaymentDashboard from 'partial/OfferManager/modules/RentPaymentDashboard';
import SelfReportedIncome from 'partial/OfferManager/modules/SelfReportedIncome';
import SesameCashSummary from 'partial/OfferManager/modules/SesameCashSummary';
import SuggestedAutoLoanOffers from 'partial/OfferManager/modules/SuggestedAutoLoanOffers';
import SuggestedPersonalLoanOffers from 'partial/OfferManager/modules/SuggestedPersonalLoanOffers';
import WhatsChangedOcfModuleController from 'partial/OfferManager/modules/WhatsChangedOcf';
import AppDownload from '../AppDownload';
import OcfHeaderTemplateModuleController from '../OcfHeaderTemplate';
import OcfOffersTemplateModuleController from '../OcfOffersTemplate';
import FrequentlyAskedQuestionsModule from 'partial/OfferManager/modules/FrequentlyAskedQuestionsModule';
import { AboutMortgagesModule } from 'partial/OfferManager/modules/HomeLoan';
import { AboutRefinanceModule } from 'partial/OfferManager/modules/HomeLoan';
import { HomeEquityMarketplaceModule } from 'partial/OfferManager/modules/HomeLoan';
import { HomeMortgageRefinanceModule } from 'partial/OfferManager/modules/HomeLoan';
import { HomeRefinanceMarketplaceModule } from 'partial/OfferManager/modules/HomeLoan';
import { NewHomeMarketplaceModule } from 'partial/OfferManager/modules/HomeLoan';
import { PaymentCalculatorModule } from 'partial/OfferManager/modules/HomeLoan';
import UpdateAddress from 'partial/OfferManager/modules/UpdateAddress';
import CardExpired from 'partial/OfferManager/modules/CardExpired';
import CardActivationModule from 'partial/OfferManager/modules/CardActivation';
/**
 * Module High level Requirements
 *
 * Each module shall....
 *   - Trigger the onModuleHideCallback if the module does not show anything
 *   - Trigger a "View Module" event if it is displaying anything
 *   - On all events, add the name of module and position
 *
 *
 *
 * @param props
 * @returns {*}
 * @constructor
 */
const Module = props => {
  switch (props?.module) {
    case 'ALERT':
      return <Alert {...props} />;
    case 'ALERT_DETAILS':
      return <NotificationAlertsDetailsModuleController {...props} />;
    case 'APP_DOWNLOAD':
      return <AppDownload {...props} />;
    case 'AUTO_DD_PENDING':
      return <AutoDDPending {...props} />;
    case 'AUTO_DD_SUCCESS':
      return <AutoDDSuccess {...props} />;
    case 'AUTO_INSURANCE':
      return <AutoInsuranceModule {...props} />;
    case 'AUTO_INSURANCE_FOR_CREDIT_SCORE_INCREASE':
      return <AutoInsuranceForCreditScoreIncrease {...props} />;
    case 'AUTO_PURCHASE_LOAN_MODULE':
      return <AutoLoanPurchaseModule {...props} />;
    case 'AUTO_REFINANCE':
      return <AutoRefinance {...props} />;
    case 'AUTO_LOAN_MARKETPLACE':
      return <AutoLoanMarketplaceModule {...props} />;
    case 'AUTO_LOAN_RATE_COMPARISON':
      return <AutoLoanRateComparisonModule {...props} />;
    case 'AUTO_REFINANCE_MARKETPLACE':
      return <AutoRefinanceMarketplaceModule {...props} />;
    case 'AUTO_INSURANCE_OCF':
      return <AutoInsuranceOcfModuleController {...props} />;
    case 'AUTO_REFINANCE_OCF':
      return <AutoRefinanceOcfModuleController {...props} />;
    case 'AUTO_PURCHASE_OCF':
      return <AutoPurchaseOcfModuleController {...props} />;
    case 'BALANCE_TRANSFER_OCF':
      return <BalanceTransferOcfModule {...props} />;
    case 'BUSINESS_LOANS_OFFERS':
      return <BusinessLoansOffers {...props} />;
    case 'BUY_CAR_TIP':
      return <BuyCarTipModule {...props} />;
    case 'CARD_SHIPPING_ADDRESS':
      return <CardShippingAddress {...props} />;
    case 'CASH_BALANCE':
      return <CashBalanceModule {...props} />;
    case 'CASH_FUND_ACCOUNT':
      return <CashFundAccount {...props} />;
    case 'CASH_PERKS':
      return <CashPerks {...props} />;
    case 'CASH_PROMO':
      return <SesameCashSummary {...props} />;
    case 'COLLECTIONS_GUIDE':
      return <CollectionGuideBanner {...props} />;
    case 'CREDIT_AGE':
      return <CreditAge {...props} />;
    case 'CREDIT_FOUNDATION':
      return <CreditFoundation {...props} />;
    case 'CREDIT_CARD_COMPARISON':
      return <CreditCardComparison {...props} />;
    case 'CREDIT_LIMIT':
      return <CreditLimit {...props} />;
    case 'CREDIT_REPAIR_EXPERT':
      return <CreditRepairExpert {...props} />;
    case 'CREDIT_REPAIR_EXPERT_TIP':
      return <CreditRepairExpertTip {...props} />;
    case 'CREDIT_UTILIZATION':
      return <CreditUtilization {...props} />;
    case 'CROA_BANNER':
      return <CROABanner {...props} />;
    case 'DEBT_ANALYSIS':
      return <DebtAnalysis {...props} />;
    case 'DEBT_RELIEF':
      return <DebtRelief {...props} />;
    case 'DIRECT_DEPOSIT_AUTOMATIC':
      return <DirectDepositAutomatic {...props} />;
    case 'DIRECT_DEPOSIT_MANUAL':
      return <DirectDepositManual {...props} />;
    case 'DISCREPANCY':
      return <DiscrepancyController {...props} />;
    case 'GENERIC_AUTO_LOAN_MODULE':
      return <GenericAutoLoanModule {...props} />;
    case 'GOAL_NEGATIVE_MARKS':
      return <GoalNegativeMarks {...props} />;
    case 'HELP_AND_QUESTIONS':
      return <HelpAndQuestions {...props} />;
    case 'HOME_LOANS_ABOUT_MORTGAGE':
      return <AboutMortgagesModule {...props} />;
    case 'HOME_PADDER':
      return <HomePadder {...props} />;
    case 'HOME_OWNER_INSURANCE_OCF':
      return <HomeOwnerInsuranceOcfModule {...props} />;
    case 'HOME_REFINANCE_OCF':
      return <HomeRefinanceOcfModuleController {...props} />;
    case 'HOME_PURCHASE_OCF':
      return <HomePurchaseOcfModuleController {...props} />;
    case 'KYC_HARD_FAIL':
      return <KYCHardFail {...props} />;
    case 'KYC_SOFT_FAIL':
      return <KYCSoftFail {...props} />;
    case 'INCREASE_SCORE_TIPS':
      return <IncreaseScoreTips {...props} />;
    case 'LIFE_INSURANCE':
      return <LifeInsuranceModule {...props} />;
    case 'LIFE_INSURANCE_OCF':
      return <LifeInsuranceOcfModuleController {...props} />;
    case 'MARKETPLACE_INSURANCE_TILE_MODULE':
      return <MarketPlaceInsuranceTilesModule {...props} />;
    case 'NEGATIVE_MARKS':
      return <NegativeMarks {...props} />;
    case 'HEADER_TEMPLATE_OCF':
      return <OcfHeaderTemplateModuleController {...props} />;
    case 'OFFERS_TEMPLATE_OCF':
      return <OcfOffersTemplateModuleController {...props} />;
    case 'HOME_LOAN_NEW':
      return <NewHomeMarketplaceModule {...props} />;
    case 'HOME_REFINANCE':
      return <HomeRefinanceMarketplaceModule {...props} />;
    case 'HOME_EQUITY':
      return <HomeEquityMarketplaceModule {...props} />;
    case 'HOME_ABOUT_REFINANCE':
      return <AboutRefinanceModule {...props} />;
    case 'HOME_MORTGAGE_REFINANCE':
      return <HomeMortgageRefinanceModule {...props} />;
    case 'PAYMENT_CALCULATOR':
      return <PaymentCalculatorModule {...props} />;
    case 'PREMIUM_UPSELL':
      return <PremiumUpsell {...props} />;
    case 'PL_PREQUAL_MODULE':
      return <PersonalLoanPrequalModule {...props} />;
    case 'PL_PREQUAL_OFFER_MODULE':
      return <PlPrequalOfferModule {...props} />;
    case 'PL_PREQUAL_HIGH_CC_DEBT_MODULE':
      return <PersonalLoanPrequalHighCcDebtModule {...props} />;
    case 'PL_PREQUAL_HIGH_SCORE':
      return <PersonalLoanHighScoreModule {...props} />;
    case 'PL_PREQUAL_LOW_SCORE':
      return <PersonalLoanLowScoreModuleController {...props} />;
    case 'PREMIUM_FEATURES':
      return <PremiumFeatures {...props} />;
    case 'PRE_APPROVED_MARKETPLACE_BANNER':
      return <MarketplacePreApprovedBanner {...props} />;
    case 'PRE_APPROVED_OCF':
      return <PreApprovedOcfModuleController {...props} />;
    case 'RECENT_CASH_TRANSACTIONS':
      return <RecentCashTransactions {...props} />;
    case 'RENT_PAYMENT_DASHBOARD':
      return <RentPaymentDashboard {...props} />;
    case 'RENTERS_INSURANCE_OCF':
      return <RentersInsuranceOcfModule {...props} />;
    case 'SELF_REPORTED_INCOME':
      return <SelfReportedIncome {...props} />;
    case 'SUGGESTED_AUTO_LOANS':
      return <SuggestedAutoLoanOffers {...props} />;
    case 'SUGGESTED_BUSINESS_CC_LOANS':
      return <SuggestedBusinessCCLoans {...props} />;
    case 'SUGGESTED_PERSONAL_LOANS':
      return <SuggestedPersonalLoanOffers {...props} />;
    case 'WHATS_CHANGED_OCF':
      return <WhatsChangedOcfModuleController {...props} />;
    case 'ONE_CLICK_APPLICATION':
      return <OneClickApplicationModule {...props} />;
    case 'NATIVE_ADS':
      return <NativeAdModule {...props} />;
    case 'FACTORS_FREQUENTLY_ASKED_QUESTIONS':
      return <FrequentlyAskedQuestionsModule {...props} />;
    case 'FEATURED_AD':
      return <FeaturedAdModule {...props} />;
    case 'PARTNER_TEXT_DISCLAIMER':
      return <PartnerTextDisclaimer {...props} />;
    case 'AUTO_INSURANCE_FOR_NEW_AUTO_LOAN':
      return <AutoInsuranceForNewAutoLoan {...props} />;
    case 'REDUCE_CREDIT_USAGE_WITH_LIMIT_INCREASE':
      return <ReduceCreditUsageWithLimitIncrease {...props} />;
    case 'UPDATE_ADDRESS':
      return <UpdateAddress {...props} />;
    case 'CARD_ACTIVATION':
      return <CardActivationModule {...props} />;
    case 'CARD_EXPIRED':
      return <CardExpired {...props} />;
    default:
      return <Default {...props} />;
  }
};

export default Module;
